import Footer from '../../molecules/Footer';
import Header from '../../molecules/Header';
import { useHistory, useParams } from 'react-router-dom';
import { getCheckOptInMailApi, updateOptInInfoApi } from '@common/external/OptInInfoApi';
import { getAgencyDetailByCustomerIdApi } from '@common/external/AgencyDetailApi';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { SCREEN, MAIL_PERMISSION_TYPE } from '@common/Common';
import { getMessageFromMasterInfo, MESSAGE_MASTER_KEYS } from '@common/redux/reducers/MasterInfoReducer';
import { API_RESULT_CD } from '@common/external/Common';
import { CustomerAppState } from '../../../redux/modules/store';
import OptinMailContent from '../../organisms/OptinMailContent';
import { customerActions } from '../../../redux/modules/Actions';

export interface OptinMailParams {
  id: string;
  optInToken: string;
}

/**
 * メール受信の許諾画面
 */
const OptinMail: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id, optInToken } = useParams<OptinMailParams>();
  const [isView, setView] = useState(false);
  const [updateDatetime, setUpdateDatetime] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [longName, setLongName] = useState('');
  const [telNo, setTelNo] = useState('');
  const [supportContactUrl, setSupportContactUrl] = useState('');
  const masterInfo = useSelector((state: CustomerAppState) => state.masterInfo);

  useEffect(() => {
    const getCheckOptInMailResult = async () => {
      const checkOptInMailResult = await getCheckOptInMailApi({ customerId: parseInt(id), optInToken });
      let redirect = '';
      // 処理結果コードが正常"0000"以外の場合
      if (checkOptInMailResult.result.resultCd !== API_RESULT_CD.OK) {
        const filterItem = checkOptInMailResult.result.resultMessageDtoList?.filter(
          (result) => result.resultMessageCd === MESSAGE_MASTER_KEYS.I_020
        ); //API規制中

        // メンテナンスコードの場合
        if (filterItem && filterItem.length > 0) {
          redirect = SCREEN.MAIL_SYS_MAINTE.URL;
        } else {
          redirect = SCREEN.MAIL_OPTIN_ERROR.URL;
        }
      } else {
        // 顧客IDとトークンのチェック結果を確認する。
        const checkResult = checkOptInMailResult.checkResult;
        if (!checkResult) {
          redirect = SCREEN.MAIL_OPTIN_ERROR.URL;
        }
      }
      // エラーがあった場合、エラー画面へリダイレクトする。
      if (redirect) {
        history.push(redirect);
      } else {
        setCustomerId(id);
        setUpdateDatetime(checkOptInMailResult.updateDatetime);
        setView(true);
      }
    };
    const getAgencyDetailByCustomerId = async () => {
      const agencyDetailByCustomerIdResult = await getAgencyDetailByCustomerIdApi({ customerId: parseInt(id) });
      if (agencyDetailByCustomerIdResult.result.resultCd === API_RESULT_CD.OK) {
        setLongName(agencyDetailByCustomerIdResult.longNm);
        setTelNo(agencyDetailByCustomerIdResult.telNo);
        setSupportContactUrl(agencyDetailByCustomerIdResult.supportContactUrl);
      }
    };
    getCheckOptInMailResult();
    getAgencyDetailByCustomerId();
  }, []); // eslint-disable-line

  const callUpdateOptinInfoApi = async (mailPermissionType: string) => {
    const acceptResult = await updateOptInInfoApi({
      customerId: parseInt(customerId),
      mailPermissionType,
      updateDatetime: updateDatetime,
    });

    if (acceptResult.result.resultCd !== API_RESULT_CD.OK) {
      const filterItem = acceptResult.result.resultMessageDtoList?.filter((result) => result.resultMessageCd === MESSAGE_MASTER_KEYS.I_020); //API規制中
      // メンテナンスコードの場合
      if (filterItem && filterItem.length > 0) {
        history.push(SCREEN.MAIL_SYS_MAINTE.URL);
      } else {
        history.push(SCREEN.MAIL_OPTIN_ERROR.URL);
      }
    } else {
      dispatch(
        customerActions.updateMailPermissionType({
          mailPermissionType: mailPermissionType,
        })
      );
      history.push(SCREEN.MAIL_OPTIN_DONE.URL);
    }
  };
  const acceptHandler = async () => {
    await callUpdateOptinInfoApi(MAIL_PERMISSION_TYPE.CONSENT_REMOTE);
  };

  const notAcceptHandler = async () => {
    await callUpdateOptinInfoApi(MAIL_PERMISSION_TYPE.DENY_REMOTE);
  };

  // 受信の承諾画面タイトル
  const optinMailTitle = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0009);
  // 受信の承諾画面詳細
  const optinMailDetail = getMessageFromMasterInfo(masterInfo, MESSAGE_MASTER_KEYS.M_0010);
  // 受信の承諾画面送信/配信元情報
  const optinMailSenderInfo = getMessageFromMasterInfo(
    masterInfo,
    MESSAGE_MASTER_KEYS.M_0024,
    String(longName),
    String(telNo),
    String(supportContactUrl)
  );

  return isView ? (
    <div>
      <Header />
      <OptinMailContent
        title={optinMailTitle}
        detail={optinMailDetail}
        senderInfo={optinMailSenderInfo}
        notAccept={notAcceptHandler}
        accept={acceptHandler}
      />
      <Footer />
    </div>
  ) : (
    <></>
  );
};
export default OptinMail;
